import axiosClient from "../axios/axiosClient";

export function getNotableAlumni() {
  return axiosClient.get("/notable-alumni");
}

export function getNotableAlumnus(notableAlumnusId) {
  return axiosClient.get(`/notable-alumni/${notableAlumnusId}`);
}

export function createNotableAlumnus(data) {
  return axiosClient.post("/notable-alumni", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export const updateNotableAlumnus = (notableAlumnusId, data) => {
  return axiosClient.post(`/notable-alumni/${notableAlumnusId}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export function deleteNotableAlumnus(notableAlumnusId) {
  return axiosClient.delete(`/notable-alumni/${notableAlumnusId}`);
}
